import { api } from './api';

export const dashboardService = {
    getCounts: () => api.get('/counts'),
};
